import type { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLDivElement> & {
	/** Extra classes for size/shape (e.g. `h-4 w-3/4`). */
	className?: string;
};

/**
 * Content-shaped loading placeholder — `wi-ink-soft` fill + `wi-pulse` (PRD §2.6).
 * Match line heights / card dimensions of the content about to arrive; no generic spinners.
 * Reduced motion → static opacity via `.wi-pulse` media query.
 */
export function SkeletonBlock({ className = "", ...rest }: Props) {
	return (
		<div
			className={["wi-pulse rounded-md bg-wi-ink-soft", className].filter(Boolean).join(" ")}
			aria-hidden="true"
			{...rest}
		/>
	);
}
